import { TextField, TextFieldProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import GeneratorAdditionalLoadUnitToggleButtonGroup from './GeneratorLoadUnitToggleButtonGroup'
import { PowerUnit } from '../enums'

export interface GeneratorAdditionalLoadFieldProps extends Omit<TextFieldProps, 'value' | 'type'> {
  value?: number
  unit?: PowerUnit
  withUnitToggle?: boolean
  onUnitChange?: (unit: PowerUnit) => void
}

export default function GeneratorAdditionalLoadField({
  value,
  unit = PowerUnit.KILOWATT,
  withUnitToggle = true,
  onUnitChange,
  name,
  label,
  helperText,
  ...props
}: GeneratorAdditionalLoadFieldProps) {
  const { t } = useTranslation('generator')

  return (
    <TextField
      type="number"
      name={name ?? 'customData.additionalLoad'}
      label={label ?? `${t('additionalLoad')} (${unit})`}
      value={value}
      variant="outlined"
      fullWidth
      InputProps={{
        endAdornment: withUnitToggle && (
          <GeneratorAdditionalLoadUnitToggleButtonGroup
            value={unit}
            color="primary"
            size="small"
            buttonProps={{
              sx: {
                py: 1
              }
            }}
            onValueChange={onUnitChange}
          />
        )
      }}
      {...props}
    />
  )
}
